var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('PageHeader',{attrs:{"links":_vm.headLinks}}),_c('div',{staticClass:"pageMain"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }